import { CSSProperties, ComponentProps } from 'react';
import { Toaster as Sonner } from 'sonner';

import { defaultSonnerConfig } from 'lib/config/sonner';

import { useTheme } from './theme/dm-theme-provider';

type ToasterProps = ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = 'system' } = useTheme();

  return (
    <Sonner
      theme={theme as ToasterProps['theme']}
      className="toaster group"
      style={
        {
          '--normal-bg': 'var(--color-popover)',
          '--normal-text': 'var(--color-popover-foreground)',
          '--normal-border': 'var(--color-border)',
        } as CSSProperties
      }
      {...defaultSonnerConfig}
      {...props}
    />
  );
};

export { Toaster };
